/**
 * Distinguir «se fue el internet» de «el programa esta roto».
 *
 * =============================================================================
 * POR QUE IMPORTA LA DISTINCION
 * =============================================================================
 * Hasta el 2026-09-06 las dos cosas se veian igual: una pantalla de emergencia
 * a pantalla completa diciendo «se atoro la pantalla» y pidiendole al mesero
 * que revisara si su pedido se habia guardado a medias.
 *
 * Para una caida de red ese consejo es FALSO y ademas asusta de gratis: si no
 * hubo conexion, la peticion no salio y no se guardo nada. Lo unico que hay que
 * hacer es esperar a que vuelva la senal.
 *
 * A ORIENTE 86 le paso dos veces en trece minutos el 25 de agosto, en plena
 * toma de pedido. Diecisiete minutos entre levantar la comanda y poder moverla.
 *
 * =============================================================================
 * COMO SE RECONOCE
 * =============================================================================
 * Cada navegador dice lo suyo, y son textos del NAVEGADOR, no nuestros — o sea
 * que pueden cambiar sin avisar (aprendizaje 2026-08-24). Por eso lo primero
 * que se mira NO es el texto sino `navigator.onLine`, que es un hecho y no una
 * frase.
 */

/**
 * Los textos con que cada navegador dice «no hay red».
 *
 *   Chrome/Edge  -> "Failed to fetch"
 *   Firefox      -> "NetworkError when attempting to fetch resource."
 *   Safari/iOS   -> "Load failed"  ·  "The network connection was lost."
 *   Safari (otro)-> "network error"
 */
const TEXTO_DE_RED =
  /failed to fetch|networkerror|network error|load failed|network connection was lost|err_internet|err_network|err_connection|connection appears to be offline|no se pudo conectar/i

/**
 * ¿Este error fue por falta de conexion?
 *
 * @param error   el error que atrapo la frontera
 * @param enLinea `navigator.onLine`; se pasa aparte para poder probarlo
 */
export function esCaidaDeRed(error: { message?: string } | null | undefined, enLinea?: boolean): boolean {
  // Un hecho gana sobre un texto: si el aparato dice que no hay red, no hay red.
  if (enLinea === false) return true
  return TEXTO_DE_RED.test(error?.message ?? '')
}
